












































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import formateData from '../../common/utils/formateData';
import { jumpToBuy } from '../../common/client-agreement/jumpAgreement';
import { controllerUse } from '../../common/show-controller/index';
const win: any = window;
const { hxmClickStat } = win;

@Component({
  components: {
  }
})
export default class StockCard extends Vue {
  public $dialog: any;
  @Prop() private readonly data!: any;
  @Prop() private readonly dataBuy!: any;
  @Prop() private readonly config!: any;
  @Prop() private readonly hasBottomPadding?: boolean;
  @Prop() private readonly maidian!: any;
  @Prop() private readonly jumpConfig!: any;

  // 监听数据改变
  @Watch('data', {immediate: false, deep: true})
  getNewData(newVal: any) {
    this.initFont();
  };

  private isUse = controllerUse('hitNewStock') || win.F10Utils.getUrlParams('fromshare');
  private riskReason: string = '';
  
  private mounted() {
    this.initFont();
  }

  /**
   * 获取当前股票的市场
   */
  private getMarket(exchange: string) {
    const marketObj: any = {
      H: { name: '沪', color: 'red' },
      S: { name: '深', color: 'red' },
      GEM: { name: '创', color: 'orange' },
      STAR: { name: '科', color: 'blue' },
      BOND: { name: '债', color: 'red' },
      J: { name: '京', color: 'red' },
    };
    return marketObj[exchange] || { name: '', color: ''};
  }

  private getFormateValue(value: number | string, unit: string) {
    return formateData(value, unit);
  }

  /**
   * 初始化没有单位的文字的字体大小
   */
  private initFont() {
    this.$nextTick(()=>{
      const outdom: any = this.$refs.tdUnit || [];
      outdom.forEach((item: any) => {
        if (item.offsetHeight > 14 * 1.5 + 6) {
          item.style.fontSize = '12px';
        }
      });
    });
  }

  /**
   * 处理申购
   */
  private handleClickBuy(orderCode: string, code: string, marketId: string, dataBuy: any) {
    if (dataBuy && dataBuy.length > 0 && dataBuy.indexOf(orderCode) > -1) {
      return
    }
    hxmClickStat(this.maidian, {});
    jumpToBuy(orderCode, code, marketId);
  }

  private handleSeeDetial() {
    this.$emit('seeDetial', {
      orderCode: this.data.orderCode,
      code: this.data.code,
      marketId: this.data.marketId,
      name: this.data.name,
      exchange: this.data.exchange,
      maidian: this.data.exchange === 'BOND' ? 'xz' : 'xg'
    })
  }

  // 判断是否显示风险提示
  private isShowRiskTip(item: any): boolean {
    if (!item || !this.data.break_probability) {
      return false;
    }
    // 只有issue_pe_static才显示风险提示
    if (item.field === 'issue_pe_static') {
      let riskTips = `根据近三个月创业板/科创板的新股数据回测，新股破发几率为${formateData(this.data.break_probability, 'rate')}，破发新股中，`;
      let res = false;
      if (Number(item.value) > Number(this.data.industry_ttm) && this.data.pe_static_ratio) {
        riskTips += `市盈率(静)大于同行业平均市盈率的股票占比为${formateData(this.data.pe_static_ratio, 'rate')}。`
        res = true;
      }
      if (Number(this.data.issue_pe_ttm) > Number(this.data.industry_ttm) && this.data.pe_ttm_ratio) {
        riskTips += `市盈率(TTM)大于同行业平均市盈率的股票占比为${formateData(this.data.pe_ttm_ratio, 'rate')}。`
        res = true;
      }
      if (Number(this.data.net_profit_growth_rate) < 0  && this.data.net_profit_growth_rate_ratio) {
        riskTips += `净利润同比增长率为负的股票占比为${formateData(this.data.net_profit_growth_rate_ratio, 'rate')}。`
        res = true;
      }
      this.riskReason = riskTips;
      return res;
    }
    return false;
  }
  // 展示风险提示
  private showTips(item: any) {
    const fxStat = this.maidian.split('.').slice(0, 3).join('.');
    if (this.isShowRiskTip(item)) {
      hxmClickStat(`${fxStat}.fx`);
      this.$dialog({
        title: '',
        content: this.riskReason,
        zIndex: 1200,
        btns: [
          {
            text: '我知道了',
            callback: () => {
              hxmClickStat(`${fxStat}.fx.close`);
            }
          }
        ]
      });
    }
  }
  // 所属行业太长缩小字体或显示...
  private flexFontSize(item: any) {
    if (item.field === 'industry_name' && item.value && item.value.length >= 6) {
      return 'mini-font';
    } else {
      return '';
    }
  }
}
